import { httpDelete, httpDelete_New, httpGet, httpGet_New, httpGetFile, httpPatch_New, httpPost, httpPost_New } from './api.service';
import { PasswordResetRequest } from '../requestModels/passwordResetRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { AppUser } from '../types/AppUser';
import { SingleResult } from '../types/SingleResult';
import { GivenPermission } from '../types/Permission';
import { AppUserInput } from '../components/pages/account/appUserForm';
import { UserMetadataResponse } from '../types/UserMetadata';
import { MobileLog } from '../types/MobileLog';

export const getAppUser = async (userId: string): Promise<AppUser> => await httpGet_New(`api/user/${userId}`);

export const updateAppUser = async (userId: string, model: AppUserInput): Promise<AppUser> => {
  // First attempt enabling/disabling the user
  try {
    await httpPost_New(`api/user/${userId}/${model.isDisabled ? 'disable' : 'enable'}`);
  } catch (err) {
    // Continue on error
    console.error('Enabling/disabling user failed', err);
  }

  // Then patch details
  return await httpPatch_New<AppUser>(`api/user/${userId}`, model);
};

export const getAppUsers = async (params): Promise<PaginatedResult<AppUser>> => await httpGet(`api/user`, params);

export const exportAppUsers = async (params): Promise<void> => await httpGetFile(`api/user/export`, params);

export const deleteUser = async (id: string): Promise<void> => await httpDelete_New(`api/user/${id}`);

export const appUserPasswordResetRequest = async (id: string): Promise<SingleResult<string>> => await httpPost(`api/user/${id}/reset-password`);

export const anonymousPasswordResetRequest = async (email: string): Promise<SingleResult<string>> =>
  await httpPost(`api/user/reset-password`, JSON.stringify(email));

export const resetAppUserPassword = async (id: string, code: string, data: PasswordResetRequest): Promise<SingleResult<any>> =>
  await httpPost(`api/user/${id}/change-password/${code}`, data);

export const unlockAppUser = async (id: string): Promise<SingleResult<string>> => await httpPost(`api/user/${id}/unlock`);

export const getUserPermissions = async (userId: string): Promise<SingleResult<GivenPermission[]>> => await httpGet(`api/user/${userId}/permission`);

export const assignUserPermission = async (userId: string, permissionCode: string): Promise<SingleResult<GivenPermission[]>> =>
  await httpPost(`api/user/${userId}/permission/${permissionCode}`);

export const revokeUserPermission = async (userId: string, permissionCode: string): Promise<SingleResult<GivenPermission[]>> =>
  await httpDelete(`api/user/${userId}/permission/${permissionCode}`);

export const getUserMetadata = async (id: string): Promise<UserMetadataResponse> => {
  const response = await httpGet<{ data: UserMetadataResponse }>(`api/user/${id}/metadata`);
  return response.data;
};

export const getMobileLogsByImei = async (params: Record<string, any>): Promise<PaginatedResult<MobileLog>> => {
  return await httpGet_New<PaginatedResult<MobileLog>>(`api/logs/mobile`, params);
};
